//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";

export default {
  name: "PlanEmailComponent",
  components: { HiCell },
  methods: {
    /**
     * 点击跳转到邮箱设置页面
     */
    cellClick() {
      this.$router.push({ name: "MyPlanEmailPage" });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/email/Index.vue